import script from "./ModalConfirm.vue?vue&type=script&lang=ts&setup=true"
export * from "./ModalConfirm.vue?vue&type=script&lang=ts&setup=true"

import "./ModalConfirm.vue?vue&type=style&index=0&id=f4a2a48c&lang=scss"

const __exports__ = script;

export default __exports__